import { combineReducers } from 'redux';
import configureStore from '../configureStore';
import rootSaga from '../sagas/';

export default () => {
  /* ------------- Assemble The Reducers ------------- */
  const rootReducer = combineReducers({
    app: require('./AppReducer').reducer,
    activation: require('./ActivationReducer').reducer,
    login: require('./LoginReducer').reducer,
    signup: require('./SignupReducer').reducer,
    resetPassword: require('./ResetPasswordReducer').reducer,
    changePassword: require('./ChangePasswordReducer').reducer,
    application: require('./ApplicationReducer').reducer,
    requesetResetPassword: require('./RequestResetPasswordReducer').reducer,
    declaration: require('./DeclarationReducer').reducer,
    configs: require('./ConfigReducer').reducer,
    payment: require('./PaymentReducer').reducer,
  });

  return configureStore(rootReducer, rootSaga);
};



// WEBPACK FOOTER //
// ./src/state/reducers/index.js